import { Component, Vue } from 'vue-property-decorator';
import WithRender from './UserState.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

const STATE_OPTIONS = [
  { value: 1, text: 'Contacted' },
  { value: null, text: 'New' },
];

@WithRender
@Component({
  components: {
    Loading
  }
})
export default class UserState extends Vue {
  isLoading = false;
  userId = '';
  fullName = '';
  userName = '';
  selectedState: any = 'unset';
  successMsg = '';
  errorMsg = '';

  stateOptions = STATE_OPTIONS;

  mounted() {
    this.userId = (this.$route.query.userId as string) || '';
    this.fullName = (this.$route.query.fullName as string) || '';
    this.userName = (this.$route.query.userName as string) || '';
  }

  updateState(): void {
    if (this.selectedState === 'unset') return;
    this.isLoading = true;
    this.successMsg = '';
    this.errorMsg = '';
    _axios.put(`${config.gateway}admin/internal/report/Users/${this.userId}/State`, { state: this.selectedState }, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(() => {
        this.successMsg = `State updated successfully to "${(this.stateOptions.find(o => o.value === this.selectedState) || { text: '' }).text}".`;
      })
      .catch(err => {
        this.errorMsg = 'Failed to update state. Please try again.';
        console.error(err);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  goBack(): void {
    this.$router.push('/usersreport');
  }
}
